<template>
  <v-col fluid class="pa-12">
    <v-row>
      <v-col cols="6">
        <v-row>
          <v-col>
            <v-card class="elevation-5">
              <v-card-title>Worker Details</v-card-title>
              <v-container fluid class="ma-2">
                <form>
                  <v-text-field
                    v-model="worker.firstname"
                    :counter="100"
                    label="First Name"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="worker.lastname"
                    :counter="100"
                    label="Last Name"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="worker.fin"
                    :counter="50"
                    label="Fin Number / NRIC "
                    disabled
                  ></v-text-field>
                  <v-text-field
                    v-model="worker.attendencetagging"
                    :counter="100"
                    label="Attendence Tagging"
                  ></v-text-field>
                  <v-select
                    v-model="worker.gender"
                    :items="genders"
                    label="Gender"
                    required
                  ></v-select>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="worker.dob"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="worker.dob"
                        label="Date Of Birth"
                        prepend-icon="event"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="worker.dob" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(worker.dob)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
                  <v-select
                    v-model="worker.nationality"
                    :items="nationalities"
                    label="Nationality"
                    required
                  ></v-select>
                  <v-text-field
                    v-model="worker.address"
                    label="Address"
                  ></v-text-field>
                  <v-text-field
                    v-model="worker.postal"
                    label="Postal Code"
                  ></v-text-field>
                  <v-text-field
                    v-model="worker.contact"
                    label="Contact"
                  ></v-text-field>
                  <v-text-field
                    v-model="worker.nokname"
                    label="Next of Kin Name"
                  ></v-text-field>
                  <v-text-field
                    v-model="worker.nokaddress"
                    label="Next of Kin address"
                  ></v-text-field>
                  <v-text-field
                    v-model="worker.nokpostal"
                    label="Next of Kin postal"
                  ></v-text-field>
                  <v-select
                    v-model="worker.statusId"
                    :items="workerstatus"
                    label="Worker Status"
                    item-text="workerstatusname"
                    item-value="workerstatusId"
                  ></v-select>
                  <v-select
                    v-model="worker.typeId"
                    :items="workertypes"
                    label="Worker Type"
                    item-text="workertypename"
                    item-value="workertypeId"
                  ></v-select>
                  <v-menu
                    ref="momapplicationmenu"
                    v-model="momapplicationmenu"
                    :close-on-content-click="false"
                    :return-value.sync="worker.momapplicationdate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="worker.momapplicationdate"
                        label="MOM Application Date"
                        prepend-icon="event"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="worker.momapplicationdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="momapplicationmenu = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="
                          $refs.momapplicationmenu.save(
                            worker.momapplicationdate
                          )
                        "
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
                  <v-menu
                    ref="startmenu"
                    v-model="startmenu"
                    :close-on-content-click="false"
                    :return-value.sync="worker.startdate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="worker.startdate"
                        label="Employed Dated"
                        prepend-icon="event"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="worker.startdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="startmenu = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.startmenu.save(worker.startdate)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
                  <v-menu
                    ref="endmenu"
                    v-model="endmenu"
                    :close-on-content-click="false"
                    :return-value.sync="worker.enddate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="worker.enddate"
                        label="Last Day Of Work"
                        prepend-icon="event"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="worker.enddate" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="endmenu = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.endmenu.save(worker.enddate)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
                  <v-textarea
                    counter
                    label="Remarks"
                    v-model="worker.remarks"
                  ></v-textarea>
                  <v-btn class="mr-4" @click="submit">Save Changes</v-btn>
                </form>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6">
        <v-row>
          <v-col>
            <v-card class="elevation-5">
              <v-data-table
                :headers="headers"
                :items="workpermits"
                sort-by="filestatusid"
                class="elevation-1"
                :loading="loading"
                loading-text="Loading... Please wait"
                :search="search"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Work Permit</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="wpdialog" persistent max-width="600px">
                      <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark v-on="on"
                          >New Work Permit</v-btn
                        >
                      </template>
                      <v-card>
                        <v-card-title>
                          <span class="headline">New Work Permit</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12">
                                <v-text-field
                                  label="Serial Number*"
                                  v-model="wp_serialno"
                                  required
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-menu
                                  ref="wpmenu"
                                  v-model="wpmenu"
                                  :close-on-content-click="false"
                                  :return-value.sync="wp_expiredate"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      v-model="wp_expiredate"
                                      label="Work Permit Expire Date"
                                      prepend-icon="event"
                                      readonly
                                      v-on="on"
                                      required
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="wp_expiredate"
                                    no-title
                                    scrollable
                                  >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="wpmenu = false"
                                      >Cancel</v-btn
                                    >
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="$refs.wpmenu.save(wp_expiredate)"
                                      >OK</v-btn
                                    >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col cols="12">
                                <v-file-input
                                  v-model="wp_file"
                                  label="Select File..."
                                ></v-file-input>
                              </v-col>
                              <v-col cols="12">
                                <v-select
                                  v-model="wp_filestatus"
                                  :items="filestatus"
                                  label="File Status"
                                  item-text="filestatusname"
                                  item-value="filestatusid"
                                ></v-select>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="wpdialog = false"
                            >Close</v-btn
                          >
                          <v-btn color="blue darken-1" @click="wp_save"
                            >Save</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    v-if="item.filename != null"
                    small
                    class="mr-2"
                    @click="downloadwp(item)"
                    >cloud_download</v-icon
                  >
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="elevation-5">
              <v-data-table
                :headers="wcsocheaders"
                :items="workercsocs"
                sort-by="filestatusid"
                class="elevation-1"
                :loading="loading"
                loading-text="Loading... Please wait"
                :search="wcsocsearch"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Worker CSOC Course</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-text-field
                      v-model="wcsocsearch"
                      append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-dialog
                      v-model="wcsocdialog"
                      persistent
                      max-width="600px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark v-on="on"
                          >New Worker CSOC Course</v-btn
                        >
                      </template>
                      <v-card>
                        <v-card-title>
                          <span class="headline">New Worker CSOC Course</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12">
                                <v-text-field
                                  label="Serial Number*"
                                  v-model="wcsoc_serialno"
                                  required
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-menu
                                  ref="wcsocmenu"
                                  v-model="wcsocmenu"
                                  :close-on-content-click="false"
                                  :return-value.sync="wcsoc_expiredate"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      v-model="wcsoc_expiredate"
                                      label="CSOC Expire Date"
                                      prepend-icon="event"
                                      readonly
                                      v-on="on"
                                      required
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="wcsoc_expiredate"
                                    no-title
                                    scrollable
                                  >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="wcsocmenu = false"
                                      >Cancel</v-btn
                                    >
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="
                                        $refs.wcsocmenu.save(wcsoc_expiredate)
                                      "
                                      >OK</v-btn
                                    >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col cols="12">
                                <v-file-input
                                  v-model="wcsoc_file"
                                  label="Select File..."
                                ></v-file-input>
                              </v-col>
                              <v-col cols="12">
                                <v-select
                                  v-model="wcsoc_filestatus"
                                  :items="filestatus"
                                  label="File Status"
                                  item-text="filestatusname"
                                  item-value="filestatusid"
                                ></v-select>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="wcsocdialog = false"
                            >Close</v-btn
                          >
                          <v-btn color="blue darken-1" @click="wcsoc_save"
                            >Save</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    v-if="item.filename != null"
                    small
                    class="mr-2"
                    @click="downloadcsoc(item)"
                    >cloud_download</v-icon
                  >
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="elevation-5">
              <v-data-table
                :headers="wcheaders"
                :items="workercontracts"
                sort-by="filestatusid"
                class="elevation-1"
                :loading="loading"
                loading-text="Loading... Please wait"
                :search="wcsearch"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Worker Contract</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-text-field
                      v-model="wcsearch"
                      append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="wcdialog" persistent max-width="600px">
                      <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark v-on="on"
                          >New Worker Contract</v-btn
                        >
                      </template>
                      <v-card>
                        <v-card-title>
                          <span class="headline">New Worker Contract</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12">
                                <v-text-field
                                  label="Serial Number*"
                                  v-model="wc_serialno"
                                  required
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-menu
                                  ref="wcmenu"
                                  v-model="wcmenu"
                                  :close-on-content-click="false"
                                  :return-value.sync="wc_expiredate"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      v-model="wc_expiredate"
                                      label="Worker Contract Expire Date"
                                      prepend-icon="event"
                                      readonly
                                      v-on="on"
                                      required
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="wc_expiredate"
                                    no-title
                                    scrollable
                                  >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="wcmenu = false"
                                      >Cancel</v-btn
                                    >
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="$refs.wcmenu.save(wc_expiredate)"
                                      >OK</v-btn
                                    >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col cols="12">
                                <v-file-input
                                  v-model="wc_file"
                                  label="Select File..."
                                ></v-file-input>
                              </v-col>
                              <v-col cols="12">
                                <v-select
                                  v-model="wc_filestatus"
                                  :items="filestatus"
                                  label="File Status"
                                  item-text="filestatusname"
                                  item-value="filestatusid"
                                ></v-select>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="wcdialog = false"
                            >Close</v-btn
                          >
                          <v-btn color="blue darken-1" @click="wc_save"
                            >Save</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    v-if="item.filename != null"
                    small
                    class="mr-2"
                    @click="downloadwc(item)"
                    >cloud_download</v-icon
                  >
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="elevation-5">
              <v-data-table
                :headers="sbheaders"
                :items="workersecuritybonds"
                sort-by="filestatusid"
                class="elevation-1"
                :loading="loading"
                loading-text="Loading... Please wait"
                :search="sbsearch"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Worker Security Bond</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-text-field
                      v-model="sbsearch"
                      append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="sbdialog" persistent max-width="600px">
                      <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark v-on="on"
                          >New Security Bond</v-btn
                        >
                      </template>
                      <v-card>
                        <v-card-title>
                          <span class="headline">New Security Bond</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12">
                                <v-text-field
                                  label="Serial Number*"
                                  v-model="sb_serialno"
                                  required
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-menu
                                  ref="sbmenu"
                                  v-model="sbmenu"
                                  :close-on-content-click="false"
                                  :return-value.sync="sb_expiredate"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      v-model="sb_expiredate"
                                      label="Security Bond Expire Date"
                                      prepend-icon="event"
                                      readonly
                                      v-on="on"
                                      required
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="sb_expiredate"
                                    no-title
                                    scrollable
                                  >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="sbmenu = false"
                                      >Cancel</v-btn
                                    >
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="$refs.sbmenu.save(sb_expiredate)"
                                      >OK</v-btn
                                    >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col cols="12">
                                <v-file-input
                                  v-model="sb_file"
                                  label="Select File..."
                                ></v-file-input>
                              </v-col>
                              <v-col cols="12">
                                <v-select
                                  v-model="sb_filestatus"
                                  :items="filestatus"
                                  label="File Status"
                                  item-text="filestatusname"
                                  item-value="filestatusid"
                                ></v-select>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="sbdialog = false"
                            >Close</v-btn
                          >
                          <v-btn color="blue darken-1" @click="sb_save"
                            >Save</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    v-if="item.filename != null"
                    small
                    class="mr-2"
                    @click="downloadsb(item)"
                    >cloud_download</v-icon
                  >
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col>
            <v-card class="elevation-5">
              <v-data-table
                :headers="wiheaders"
                :items="workerinsurances"
                sort-by="filestatusid"
                class="elevation-1"
                :loading="loading"
                loading-text="Loading... Please wait"
                :search="wisearch"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Worker Insurance</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-text-field
                      v-model="wisearch"
                      append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="widialog" persistent max-width="600px">
                      <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark v-on="on"
                          >New Worker Insurance</v-btn
                        >
                      </template>
                      <v-card>
                        <v-card-title>
                          <span class="headline">New Worker Insurance</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12">
                                <v-select
                                  v-model="wi_company"
                                  :items="wicompany"
                                  label="Insurance Company"
                                ></v-select>
                              </v-col>
                              <v-col cols="12">
                                <v-text-field
                                  label="Serial Number*"
                                  v-model="wi_serialno"
                                  required
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-menu
                                  ref="wimenu"
                                  v-model="wimenu"
                                  :close-on-content-click="false"
                                  :return-value.sync="wi_expiredate"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      v-model="wi_expiredate"
                                      label="Insurance Expire Date"
                                      prepend-icon="event"
                                      readonly
                                      v-on="on"
                                      required
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="wi_expiredate"
                                    no-title
                                    scrollable
                                  >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="wimenu = false"
                                      >Cancel</v-btn
                                    >
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="$refs.wimenu.save(wi_expiredate)"
                                      >OK</v-btn
                                    >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col cols="12">
                                <v-file-input
                                  v-model="wi_file"
                                  label="Select File..."
                                ></v-file-input>
                              </v-col>
                              <v-col cols="12">
                                <v-select
                                  v-model="wi_filestatus"
                                  :items="filestatus"
                                  label="File Status"
                                  item-text="filestatusname"
                                  item-value="filestatusid"
                                ></v-select>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="widialog = false"
                            >Close</v-btn
                          >
                          <v-btn color="blue darken-1" @click="wi_save"
                            >Save</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    v-if="item.filename != null"
                    small
                    class="mr-2"
                    @click="downloadwi(item)"
                    >cloud_download</v-icon
                  >
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row> -->
        <v-row>
          <v-col>
            <v-card class="elevation-5">
              <v-data-table
                :headers="wppheaders"
                :items="workerpassports"
                sort-by="filestatusid"
                class="elevation-1"
                :loading="loading"
                loading-text="Loading... Please wait"
                :search="wppsearch"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Worker Passport</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-text-field
                      v-model="wppsearch"
                      append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="wppdialog" persistent max-width="600px">
                      <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark v-on="on"
                          >New Worker Passport</v-btn
                        >
                      </template>
                      <v-card>
                        <v-card-title>
                          <span class="headline">New Worker Passport</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12"> </v-col>
                              <v-col cols="12">
                                <v-text-field
                                  label="Full Name"
                                  v-model="wpp_fullname"
                                  required
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-text-field
                                  label="Passport Number"
                                  v-model="wpp_passportnumber"
                                  required
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-select
                                  v-model="wpp_gender"
                                  :items="genders"
                                  label="Gender"
                                  required
                                ></v-select>
                              </v-col>
                              <v-col cols="12">
                                <v-menu
                                  ref="wppissuemenu"
                                  v-model="wppissuemenu"
                                  :close-on-content-click="false"
                                  :return-value.sync="wpp_issuedate"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      v-model="wpp_issuedate"
                                      label="Passport Issue Date"
                                      prepend-icon="event"
                                      readonly
                                      v-on="on"
                                      required
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="wpp_issuedate"
                                    no-title
                                    scrollable
                                  >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="wppissuemenu = false"
                                      >Cancel</v-btn
                                    >
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="
                                        $refs.wppissuemenu.save(wpp_issuedate)
                                      "
                                      >OK</v-btn
                                    >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col cols="12">
                                <v-menu
                                  ref="wppmenu"
                                  v-model="wppmenu"
                                  :close-on-content-click="false"
                                  :return-value.sync="wpp_expiredate"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      v-model="wpp_expiredate"
                                      label="Passport Expire Date"
                                      prepend-icon="event"
                                      readonly
                                      v-on="on"
                                      required
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="wpp_expiredate"
                                    no-title
                                    scrollable
                                  >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="wppmenu = false"
                                      >Cancel</v-btn
                                    >
                                    <v-btn
                                      text
                                      color="primary"
                                      @click="
                                        $refs.wppmenu.save(wpp_expiredate)
                                      "
                                      >OK</v-btn
                                    >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col cols="12">
                                <v-file-input
                                  v-model="wpp_file"
                                  label="Select File..."
                                ></v-file-input>
                              </v-col>
                              <v-col cols="12">
                                <v-select
                                  v-model="wpp_filestatus"
                                  :items="filestatus"
                                  label="File Status"
                                  item-text="filestatusname"
                                  item-value="filestatusid"
                                ></v-select>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="wppdialog = false"
                            >Close</v-btn
                          >
                          <v-btn color="primary" @click="wpp_save">Save</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    v-if="item.filename != null"
                    small
                    class="mr-2"
                    @click="downloadwpp(item)"
                    >cloud_download</v-icon
                  >
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="elevation-5">
              <v-data-table
                :headers="wecheaders"
                :items="workercerts"
                sort-by="workerCertificationid"
                class="elevation-1"
                :loading="loading"
                loading-text="Loading... Please wait"
                :search="wecsearch"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Worker Certification</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-text-field
                      v-model="wecsearch"
                      append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="wecdialog" persistent max-width="600px">
                      <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark v-on="on"
                          >New Worker Certification</v-btn
                        >
                      </template>
                      <v-card>
                        <v-card-title>
                          <span class="headline">New Worker Certification</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12">
                                <v-text-field
                                  label="Certification Name*"
                                  v-model="wec_name"
                                  required
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-file-input
                                  v-model="wec_file"
                                  label="Select File..."
                                ></v-file-input>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="wecdialog = false"
                            >Close</v-btn
                          >
                          <v-btn color="primary" @click="wec_save">Save</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    v-if="item.filename != null"
                    small
                    class="mr-2"
                    @click="downloadwec(item)"
                    >cloud_download</v-icon
                  >
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-col>
</template>
<script>
import ApiService from '@/services/api.service'

export default {
  name: 'hr_view_worker',
  data: () => ({
    wpdialog: false,
    sbdialog: false,
    wcdialog: false,
    widialog: false,
    wppdialog: false,
    wecdialog: false,
    wcsocdialog: false,
    worker: {
      address: '',
      contact: '',
      dob: '',
      fin: '',
      attendencetagging: '',
      firstname: '',
      gender: '',
      lastname: '',
      nationality: '',
      nokaddress: '',
      nokname: '',
      nokphone: '',
      nokpostal: '',
      picture: '',
      postal: '',
      remarks: '',
      statusId: '',
      typeId: '',
      workerId: '',
      startdate: '',
      enddate: '',
      momapplicationdate: ''
    },
    wp_expiredate: '',
    wp_filestatus: '',
    menu: null,
    startmenu: null,
    endmenu: null,
    momapplicationmenu: null,
    wpmenu: null,
    genders: ['Male', 'Female'],
    nationalities: [
      'Singaporean',
      'Indian',
      'Thai',
      'Afghan',
      'Albanian',
      'Algerian',
      'American',
      'Andorran',
      'Angolan',
      'Antiguans',
      'Argentinean',
      'Armenian',
      'Australian',
      'Austrian',
      'Azerbaijani',
      'Bahamian',
      'Bahraini',
      'Bangladeshi',
      'Barbadian',
      'Barbudans',
      'Batswana',
      'Belarusian',
      'Belgian',
      'Belizean',
      'Beninese',
      'Bhutanese',
      'Bolivian',
      'Bosnian',
      'Brazilian',
      'British',
      'Bruneian',
      'Bulgarian',
      'Burkinabe',
      'Burmese',
      'Burundian',
      'Cambodian',
      'Cameroonian',
      'Canadian',
      'Cape Verdean',
      'Central African',
      'Chadian',
      'Chilean',
      'Chinese',
      'Colombian',
      'Comoran',
      'Congolese',
      'Costa Rican',
      'Croatian',
      'Cuban',
      'Cypriot',
      'Czech',
      'Danish',
      'Djibouti',
      'Dominican',
      'Dutch',
      'East Timorese',
      'Ecuadorean',
      'Egyptian',
      'Emirian',
      'Equatorial Guinean',
      'Eritrean',
      'Estonian',
      'Ethiopian',
      'Fijian',
      'Filipino',
      'Finnish',
      'French',
      'Gabonese',
      'Gambian',
      'Georgian',
      'German',
      'Ghanaian',
      'Greek',
      'Grenadian',
      'Guatemalan',
      'Guinea-Bissauan',
      'Guinean',
      'Guyanese',
      'Haitian',
      'Herzegovinian',
      'Honduran',
      'Hungarian',
      'I-Kiribati',
      'Icelander',
      'Indonesian',
      'Iranian',
      'Iraqi',
      'Irish',
      'Israeli',
      'Italian',
      'Ivorian',
      'Jamaican',
      'Japanese',
      'Jordanian',
      'Kazakhstani',
      'Kenyan',
      'Kittian and Nevisian',
      'Kuwaiti',
      'Kyrgyz',
      'Laotian',
      'Latvian',
      'Lebanese',
      'Liberian',
      'Libyan',
      'Liechtensteiner',
      'Lithuanian',
      'Luxembourger',
      'Macedonian',
      'Malagasy',
      'Malawian',
      'Malaysian',
      'Maldivan',
      'Malian',
      'Maltese',
      'Marshallese',
      'Mauritanian',
      'Mauritian',
      'Mexican',
      'Micronesian',
      'Moldovan',
      'Monacan',
      'Mongolian',
      'Moroccan',
      'Mosotho',
      'Motswana',
      'Mozambican',
      'Namibian',
      'Nauruan',
      'Nepalese',
      'New Zealander',
      'Nicaraguan',
      'Nigerian',
      'Nigerien',
      'North Korean',
      'Northern Irish',
      'Norwegian',
      'Omani',
      'Pakistani',
      'Palauan',
      'Panamanian',
      'Papua New Guinean',
      'Paraguayan',
      'Peruvian',
      'Polish',
      'Portuguese',
      'Qatari',
      'Romanian',
      'Russian',
      'Rwandan',
      'Saint Lucian',
      'Salvadoran',
      'Samoan',
      'San Marinese',
      'Sao Tomean',
      'Saudi',
      'Scottish',
      'Senegalese',
      'Serbian',
      'Seychellois',
      'Sierra Leonean',
      'Slovakian',
      'Slovenian',
      'Solomon Islander',
      'Somali',
      'South African',
      'South Korean',
      'Spanish',
      'Sri Lankan',
      'Sudanese',
      'Surinamer',
      'Swazi',
      'Swedish',
      'Swiss',
      'Syrian',
      'Taiwanese',
      'Tajik',
      'Tanzanian',
      'Togolese',
      'Tongan',
      'Trinidadian/Tobagonian',
      'Tunisian',
      'Turkish',
      'Tuvaluan',
      'Ugandan',
      'Ukrainian',
      'Uruguayan',
      'Uzbekistani',
      'Venezuelan',
      'Vietnamese',
      'Welsh',
      'Yemenite',
      'Zambian',
      'Zimbabwean'
    ],
    workertypes: null,
    workerstatus: null,
    filestatus: null,
    loading: false,
    workpermits: [],
    headers: [
      { text: 'Serial No', value: 'serialno' },
      { text: 'Expire Date', value: 'expiredate' },
      { text: 'File Name', value: 'filename' },
      { text: 'Status', value: 'filestatusname' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    search: '',
    wp_file: null,
    wp_serialno: '',
    workersecuritybonds: [],
    sb_file: null,
    sb_serialno: '',
    sb_expiredate: '',
    sb_filestatus: '',
    sbmenu: null,
    sbheaders: [
      { text: 'Serial No', value: 'serialno' },
      { text: 'Expire Date', value: 'expiredate' },
      { text: 'File Name', value: 'filename' },
      { text: 'Status', value: 'filestatusname' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    sbsearch: '',
    workercsocs: [],
    wcsoc_file: null,
    wcsoc_serialno: '',
    wcsoc_expiredate: '',
    wcsoc_filestatus: '',
    wcsocmenu: null,
    wcsocheaders: [
      { text: 'Serial No', value: 'serialno' },
      { text: 'Expire Date', value: 'expiredate' },
      { text: 'File Name', value: 'filename' },
      { text: 'Status', value: 'filestatusname' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    wcsocsearch: '',
    workercontracts: [],
    wc_file: null,
    wc_serialno: '',
    wc_expiredate: '',
    wc_filestatus: '',
    wcmenu: null,
    wcheaders: [
      { text: 'Serial No', value: 'serialno' },
      { text: 'Expire Date', value: 'expiredate' },
      { text: 'File Name', value: 'filename' },
      { text: 'Status', value: 'filestatusname' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    wcsearch: '',
    workerinsurances: [],
    wi_file: null,
    wi_serialno: '',
    wi_expiredate: '',
    wi_filestatus: '',
    wi_company: '',
    wimenu: null,
    wiheaders: [
      { text: 'Company', value: 'company' },
      { text: 'Serial No', value: 'serialno' },
      { text: 'Expire Date', value: 'expiredate' },
      { text: 'File Name', value: 'filename' },
      { text: 'Status', value: 'filestatusname' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    wisearch: '',
    wicompany: [
      'Aviva',
      'AIA',
      'NTUC INCOME',
      'Prudential',
      'Liberty insurance'
    ],
    workerpassports: [],
    wpp_file: null,
    wpp_fullname: '',
    wpp_passportnumber: '',
    wpp_expiredate: '',
    wpp_gender: '',
    wpp_issuedate: '',
    wpp_filestatus: '',
    wppmenu: null,
    wppissuemenu: null,
    wppheaders: [
      { text: 'Passport No', value: 'passportnumber' },
      { text: 'Name', value: 'fullname' },
      { text: 'Expire Date', value: 'expiredate' },
      { text: 'Issue Date', value: 'issuedate' },
      { text: 'Gender', value: 'gender' },
      { text: 'File Name', value: 'filename' },
      { text: 'Status', value: 'filestatusname' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    wppsearch: '',
    workercerts: [],
    wec_file: null,
    wec_name: '',
    wecheaders: [
      { text: 'Certification Name', value: 'certname' },
      { text: 'File Name', value: 'filename' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    wecsearch: ''
  }),
  created() {
    this.initialize()
  },
  methods: {
    initialize() {
      this.submitBtnLoading = true
      let routeworkerid = this.$route.params.id
      ApiService.get('/WorkerType')
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.workertypes = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false

            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
      ApiService.get('/WorkerStatus')
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.workerstatus = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false
            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
      ApiService.get('/Worker/' + routeworkerid)
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.worker = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false
            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
      ApiService.get('/FileStatus')
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.filestatus = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false

            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
      ApiService.get('/WorkerWorkPermit/' + routeworkerid)
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.workpermits = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false

            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
      ApiService.get('/WorkerSecurityBond/' + routeworkerid)
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.workersecuritybonds = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false

            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
      ApiService.get('/WorkerContract/' + routeworkerid)
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.workercontracts = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false

            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
      ApiService.get('/WorkerInsurance/' + routeworkerid)
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.workerinsurances = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false

            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
      ApiService.get('/WorkerCsoc/' + routeworkerid)
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.workercsocs = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false

            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
      ApiService.get('/WorkerPassport/' + routeworkerid)
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.workerpassports = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false

            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
      ApiService.get('/WorkerCertification/' + routeworkerid)
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.workercerts = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false

            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    downloadwp(item) {
      ApiService.customRequest({
        method: 'get',
        url: '/WorkerWorkPermit/' + item.workpermitid + '/download',
        responseType: 'blob'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]))
          var fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', item.filename)
          document.body.appendChild(fileLink)

          fileLink.click()
        })
        .catch(() => {
          this.loading = false
        })
    },
    downloadsb(item) {
      ApiService.customRequest({
        method: 'get',
        url: '/WorkerSecurityBond/' + item.worksecuritybondid + '/download',
        responseType: 'blob'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]))
          var fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', item.filename)
          document.body.appendChild(fileLink)

          fileLink.click()
        })
        .catch(() => {
          this.loading = false
        })
    },
    downloadcsoc(item) {
      ApiService.customRequest({
        method: 'get',
        url: '/WorkerCsoc/' + item.workercsocid + '/download',
        responseType: 'blob'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]))
          var fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', item.filename)
          document.body.appendChild(fileLink)

          fileLink.click()
        })
        .catch(() => {
          this.loading = false
        })
    },
    downloadwc(item) {
      ApiService.customRequest({
        method: 'get',
        url: '/WorkerContract/' + item.workercontractid + '/download',
        responseType: 'blob'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]))
          var fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', item.filename)
          document.body.appendChild(fileLink)

          fileLink.click()
        })
        .catch(() => {
          this.loading = false
        })
    },
    downloadwi(item) {
      ApiService.customRequest({
        method: 'get',
        url: '/WorkerInsurance/' + item.workerinsuranceid + '/download',
        responseType: 'blob'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]))
          var fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', item.filename)
          document.body.appendChild(fileLink)

          fileLink.click()
        })
        .catch(() => {
          this.loading = false
        })
    },
    downloadwpp(item) {
      ApiService.customRequest({
        method: 'get',
        url: '/WorkerPassport/' + item.workerpassportid + '/download',
        responseType: 'blob'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]))
          var fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', item.filename)
          document.body.appendChild(fileLink)

          fileLink.click()
        })
        .catch(() => {
          this.loading = false
        })
    },
    downloadwec(item) {
      ApiService.customRequest({
        method: 'get',
        url: '/WorkerCertification/' + item.workerCertificationid + '/download',
        responseType: 'blob'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]))
          var fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', item.filename)
          document.body.appendChild(fileLink)

          fileLink.click()
        })
        .catch(() => {
          this.loading = false
        })
    },
    wp_save() {
      if (this.wp_file != null) {
        if (this.wp_file.size > 1024 * 1024 * 5) {
          alert('File too big less than 5mb')
          return
        }
      }

      let serialno = this.wp_serialno
      let expiredate = this.wp_expiredate
      let filestatusid = this.wp_filestatus
      let workerId = this.worker.workerId
      let parent = this

      let formData = new FormData()
      formData.append('file', this.wp_file)
      formData.append('serialno', serialno)
      formData.append('expiredate', expiredate)
      formData.append('filestatusid', filestatusid)

      ApiService.customRequest({
        method: 'post',
        url: '/WorkerWorkPermit/' + workerId,
        data: formData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
        .then(res => {
          if (res.data.success) {
            this.wp_serialno = ''
            this.wp_expiredate = ''
            this.wp_filestatus = ''
            this.file = null
            this.wp_file = null

            this.$swal('', res.data.respond, 'success').then(function() {
              parent.wpdialog = false
              parent.initialize()
            })
          } else {
            this.$swal('', res.data.error, 'error')
          }
        })
        .catch(() => {
          this.$swal('', 'Something Went wrong', 'error')
          this.loading = false
        })
    },
    sb_save() {
      if (this.sb_file != null) {
        if (this.sb_file.size > 1024 * 1024 * 5) {
          alert('File too big less than 5mb')
          return
        }
      }

      let serialno = this.sb_serialno
      let expiredate = this.sb_expiredate
      let filestatusid = this.sb_filestatus
      let workerId = this.worker.workerId
      let parent = this

      let formData = new FormData()
      formData.append('file', this.sb_file)
      formData.append('serialno', serialno)
      formData.append('expiredate', expiredate)
      formData.append('filestatusid', filestatusid)

      ApiService.customRequest({
        method: 'post',
        url: '/WorkerSecurityBond/' + workerId,
        data: formData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
        .then(res => {
          if (res.data.success) {
            this.sb_serialno = ''
            this.sb_expiredate = ''
            this.sb_filestatus = ''
            this.file = ''
            this.sb_file = null

            this.$swal('', res.data.respond, 'success').then(function() {
              parent.sbdialog = false
              parent.initialize()
            })
          } else {
            this.$swal('', res.data.error, 'error')
          }
        })
        .catch(() => {
          this.$swal('', 'Something Went wrong', 'error')
          this.loading = false
        })
    },
    wcsoc_save() {
      if (this.wcsoc_file != null) {
        if (this.wcsoc_file.size > 1024 * 1024 * 5) {
          alert('File too big less than 5mb')
          return
        }
      }

      let serialno = this.wcsoc_serialno
      let expiredate = this.wcsoc_expiredate
      let filestatusid = this.wcsoc_filestatus
      let workerId = this.worker.workerId
      let parent = this

      let formData = new FormData()
      formData.append('file', this.wcsoc_file)
      formData.append('serialno', serialno)
      formData.append('expiredate', expiredate)
      formData.append('filestatusid', filestatusid)

      ApiService.customRequest({
        method: 'post',
        url: '/WorkerCsoc/' + workerId,
        data: formData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
        .then(res => {
          if (res.data.success) {
            this.wcsoc_serialno = ''
            this.wcsoc_expiredate = ''
            this.wcsoc_filestatus = ''
            this.file = ''
            this.wcsoc_file = null

            this.$swal('', res.data.respond, 'success').then(function() {
              parent.wcsocdialog = false
              parent.initialize()
            })
          } else {
            this.$swal('', res.data.error, 'error')
          }
        })
        .catch(() => {
          this.$swal('', 'Something Went wrong', 'error')
          this.loading = false
        })
    },
    wc_save() {
      if (this.wc_file != null) {
        if (this.wc_file.size > 1024 * 1024 * 5) {
          alert('File too big less than 5mb')
          return
        }
      }

      let serialno = this.wc_serialno
      let expiredate = this.wc_expiredate
      let filestatusid = this.wc_filestatus
      let workerId = this.worker.workerId
      let parent = this

      let formData = new FormData()
      formData.append('file', this.wc_file)
      formData.append('serialno', serialno)
      formData.append('expiredate', expiredate)
      formData.append('filestatusid', filestatusid)

      ApiService.customRequest({
        method: 'post',
        url: '/WorkerContract/' + workerId,
        data: formData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
        .then(res => {
          if (res.data.success) {
            this.wc_serialno = ''
            this.wc_expiredate = ''
            this.wc_filestatus = ''
            this.file = ''
            this.wc_file = null

            this.$swal('', res.data.respond, 'success').then(function() {
              parent.wcdialog = false
              parent.initialize()
            })
          } else {
            this.$swal('', res.data.error, 'error')
          }
        })
        .catch(() => {
          this.$swal('', 'Something Went wrong', 'error')
          this.loading = false
        })
    },

    wi_save() {
      if (this.wi_file != null) {
        if (this.wi_file.size > 1024 * 1024 * 5) {
          alert('File too big less than 5mb')
          return
        }
      }
      let company = this.wi_company
      let serialno = this.wi_serialno
      let expiredate = this.wi_expiredate
      let filestatusid = this.wi_filestatus
      let workerId = this.worker.workerId
      let parent = this

      let formData = new FormData()
      formData.append('company', company)
      formData.append('file', this.wi_file)
      formData.append('serialno', serialno)
      formData.append('expiredate', expiredate)
      formData.append('filestatusid', filestatusid)

      ApiService.customRequest({
        method: 'post',
        url: '/WorkerInsurance/' + workerId,
        data: formData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
        .then(res => {
          if (res.data.success) {
            this.wi_serialno = ''
            this.wi_expiredate = ''
            this.wi_filestatus = ''
            this.file = ''
            this.wi_file = null
            this.wicompany = ''

            this.$swal('', res.data.respond, 'success').then(function() {
              parent.widialog = false
              parent.initialize()
            })
          } else {
            this.$swal('', res.data.error, 'error')
          }
        })
        .catch(() => {
          this.$swal('', 'Something Went wrong', 'error')
          this.loading = false
        })
    },
    wpp_save() {
      if (this.wpp_file != null) {
        if (this.wpp_file.size > 1024 * 1024 * 5) {
          alert('File too big less than 5mb')
          return
        }
      }

      let fullname = this.wpp_fullname
      let passportnumber = this.wpp_passportnumber
      let expiredate = this.wpp_expiredate
      let gender = this.wpp_gender
      let issuedate = this.wpp_issuedate
      let filestatusid = this.wpp_filestatus
      let workerId = this.worker.workerId
      let parent = this

      let formData = new FormData()
      formData.append('fullname', fullname)
      formData.append('file', this.wpp_file)
      formData.append('passportnumber', passportnumber)
      formData.append('gender', gender)
      formData.append('issuedate', issuedate)
      formData.append('expiredate', expiredate)
      formData.append('filestatusid', filestatusid)

      ApiService.customRequest({
        method: 'post',
        url: '/WorkerPassport/' + workerId,
        data: formData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
        .then(res => {
          if (res.data.success) {
            this.wpp_fullname = ''
            this.wpp_expiredate = ''
            this.wpp_issuedate = ''
            this.wpp_passportnumber = ''
            this.wpp_gender = ''
            this.file = ''
            this.wpp_file = null
            this.wpp_gender = ''

            this.$swal('', res.data.respond, 'success').then(function() {
              parent.wppdialog = false
              parent.initialize()
            })
          } else {
            this.$swal('', res.data.error, 'error')
          }
        })
        .catch(() => {
          this.$swal('', 'Something Went wrong', 'error')
          this.loading = false
        })
    },
    wec_save() {
      if (this.wec_file != null) {
        if (this.wec_file.size > 1024 * 1024 * 5) {
          alert('File too big less than 5mb')
          return
        }
      }

      let name = this.wec_name
      let workerId = this.worker.workerId
      let parent = this

      let formData = new FormData()
      formData.append('certname', name)
      formData.append('file', this.wec_file)

      ApiService.customRequest({
        method: 'post',
        url: '/WorkerCertification/' + workerId,
        data: formData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
        .then(res => {
          if (res.data.success) {
            this.wec_name = ''
            this.file = ''
            this.wec_file = null

            this.$swal('', res.data.respond, 'success').then(function() {
              parent.wecdialog = false
              parent.initialize()
            })
          } else {
            this.$swal('', res.data.error, 'error')
          }
        })
        .catch(() => {
          this.$swal('', 'Something Went wrong', 'error')
          this.loading = false
        })
    },
    submit() {
      let workerId = this.worker.workerId
      let firstname = this.worker.firstname
      let lastname = this.worker.lastname
      let fin = this.worker.fin
      let attendencetagging = this.worker.attendencetagging
      let gender = this.worker.gender
      let dob = this.worker.dob
      let nationality = this.worker.nationality
      let address = this.worker.address
      let postal = this.worker.postal
      let contact = this.worker.contact
      let remarks = this.worker.remarks
      let startdate = this.worker.startdate
      let enddate = this.worker.enddate
      let nokname = this.worker.nokname
      let nokphone = this.worker.nokphone
      let nokaddress = this.worker.nokaddress
      let nokpostal = this.worker.nokpostal
      let momapplicationdate = this.worker.momapplicationdate
      let statusid = this.worker.statusId
      let typeid = this.worker.typeId

      ApiService.put('/Worker/' + workerId, {
        firstname,
        lastname,
        fin,
        attendencetagging,
        gender,
        dob,
        nationality,
        address,
        postal,
        contact,
        remarks,
        startdate,
        enddate,
        nokname,
        nokphone,
        nokaddress,
        nokpostal,
        momapplicationdate,
        statusid,
        typeid
      })
        .then(res => {
          if (res.data.success) {
            this.$swal('', res.data.respond, 'success').then(function() {})
          } else {
            this.$swal('', res.data.error, 'error')
          }
        })
        .catch(() => {
          this.$swal('', 'Something Went wrong', 'error')
          this.loading = false
        })
    }
  }
}

//$route.params.id
</script>
